<div class="ili-panel inquiry_panel">
  <p style="font-size: 11px;" class="mb-10">{{'Separate multiple email addresses with a comma followed by a space' |
    translate}}</p>
  <mat-form-field class="w-full">
    <input matInput [(ngModel)]="block.data.email" class="form-control input-sm" type="text"
      placeholder="{{'To email address' | translate}}">
  </mat-form-field>
  <mat-form-field class="w-full">
    <input matInput [(ngModel)]="block.data.inquiryText" class="form-control input-sm" type="text"
      placeholder="{{'Type your inquiry here' | translate}}">
  </mat-form-field>
</div>